import React from 'react';
import Header from 'components/Header';
import SocialMediaContact from 'components/SocialMediaContact';

export default function Contact() {
  return (
    <div className="">
      <Header />
      <main className="main contactPage">
        <section className="section intro">
          <h2>Contact </h2>
          <p>We are always happy to answer all your questions or inquiries.</p>
          <p>Say Hello.</p>

          <SocialMediaContact />
        </section>

        <section>
          <div className="email-contact">
            <p>Send us an email</p>
            <a href="mailto:contact@ravenlivestream.com" className="button">
              Contact@ravenlivestream.com
            </a>
          </div>
        </section>
      </main>
    </div>
  );
}
